import moment from "moment-timezone";
import { TimeZone } from "@vvo/tzdb";
import { TimezoneOption } from "../timezones.types";
import getOffsetHoursFromIANATimezone from "./getOffsetHoursFromIANATimezone";

export function makeTimezoneOptionFromTzdbTimezone(
  timezone: TimeZone
): TimezoneOption {
  const now = moment().tz(timezone.name);

  const offset = now.format("Z"); // e.g. "-04:00"

  const abbr = now.format("z"); // e.g. "EDT"

  const isUtcGroup =
    timezone.name === "Etc/UTC" || timezone.group.includes("Etc/UTC");

  const value = isUtcGroup ? "UTC" : timezone.name;

  const label = `(GMT${offset}) ${timezone.alternativeName} – ${timezone.mainCities[0]} (${abbr})`;

  return {
    ...timezone,
    value,
    label,
    offsetHours: getOffsetHoursFromIANATimezone(timezone),
  } as TimezoneOption;
}

export default makeTimezoneOptionFromTzdbTimezone;
